var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "sui-container",
        [
          _vm.hasCompletedAllSteps
            ? _c("CompletedStepsMessage", {
                attrs: { "has-completed-steps": _vm.hasCompletedAllSteps },
              })
            : _vm._e(),
          _c(
            "sui-step-group",
            { attrs: { stackable: "", size: "mini" } },
            [
              _c(
                "sui-step",
                { tag: "a" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "clientAgreement" } } },
                    [
                      _c("sui-step", {
                        attrs: {
                          title: "Client Agreement Profile",
                          icon: "file",
                          completed: _vm.hasSubmittedClientAgreement,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.user.profile.is_exhibit_b_investor_profile_form_user
                ? _c(
                    "sui-step",
                    { tag: "a" },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "investorProfile" } } },
                        [
                          _c("sui-step", {
                            attrs: {
                              title: "Exhibit B: Investor(s) Profile",
                              icon: "file",
                              disabled: _vm.isInvestorProfileFormDisabled,
                              completed: _vm.isInvestorProfileSubmitted,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "sui-step",
                { tag: "a" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "formADV" } } },
                    [
                      _c("sui-step", {
                        attrs: {
                          title: "Form ADV Part 2A and 2B",
                          icon: "file",
                          disabled: _vm.isFormAdvDisabled,
                          completed: _vm.hasViewedOrDownloadedFormADV,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-step",
                { tag: "a" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "formCRS" } } },
                    [
                      _c("sui-step", {
                        attrs: {
                          title: "Form CRS",
                          icon: "file",
                          disabled: _vm.isFormCrsDisabled,
                          completed: _vm.hasViewedOrDownloadedFormCRS,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("router-view"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }